import { React, i18n, inject, observer, mui, ui } from "aaa";
import { Loan } from "models/Loan";
import { numberToPercentageString, numberToCurrencyStringShort, numberToCurrencyString } from "util/helpers";

type IProps = i18n.InjectedIntlProps & {
    loan?: Loan;
};

let __: any;

const styleBox = {
    positin: "absolute",
    margin: "10px 20px 10px 10px",
    height: 80,
    width: 250,
    display: "inline-block",
    borderRight: "4px solid #ffffff",
    borderRadius: "none",
    textAlign: "left",
    padding: 4,
    backgroundColor: "none"
};

const styleText = {
    textAlign: "right",
    fontSize: "12.5px",
    margin: 0,
    padding: "1.5px 5px 1.5px 1.5px",
    color: "white",
    letterSpacing: 1
};


@i18n.injectIntl
@inject("loan")
@observer
export class CreditInfoBox extends React.Component<IProps, {}> {


    constructor(props: IProps) {
        super(props);
        __ = i18n.bindStr(this.props.intl);

    }

    render() {
        const { totalAmount, durationInYears, interestRateEffective, monthlyRate } = this.props.loan!;

        return (
            <mui.Paper zDepth={0} style={styleBox}>
                <p style={styleText}>{ui.__("loan.amountTotal")}: {numberToCurrencyString(totalAmount)}</p>
                <p style={styleText}>{ui.__("loan.duration")}: {ui.__("loan.durationYears", { duration: durationInYears })}</p>
                <p style={styleText}>{ui.__("loan.interestRateEffective")}: {numberToPercentageString(interestRateEffective)}</p>
                <p style={styleText}>{ui.__("loan.monthlyRate")}: {numberToCurrencyString(monthlyRate)}</p>
            </mui.Paper>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CreditInfoBox.tsx